import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function Introducing() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-24" data-id="element-192" data-mp="1lddskupwuz43">
      <div className="mx-auto max-w-3xl" data-id="element-193" data-mp="1zdx0m1udm569">
        <SectionHeading eyebrow="Introducing Perio Blueprint™" title="A Visual Framework for Organizing Periodontal Knowledge" data-id="element-194" data-mp="1zcvn7qpw16ld" />

        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-ink/85 sm:text-lg" data-id="element-195" data-mp="16ozka49q6ig5">
          <p className="font-serif text-2xl font-bold leading-snug text-ink" data-id="element-196" data-mp="12ne9qpknyg94">
            The problem isn’t necessarily that you need another textbook.
          </p>
          <p data-id="element-197" data-mp="1ggdmwkwz3ydi">
            You may already have lecture notes, clinical references, scientific articles, courses, and years of education.
          </p>
          <p data-id="element-198" data-mp="ny8a50hwyo0p">
            What you may need is a <strong data-id="element-199" data-mp="nx6xwsp5vvhe">clearer way to connect that information</strong> when you’re reviewing a
            periodontal case.
          </p>
          <blockquote className="border-l-4 border-gum py-1 pl-5 font-serif text-xl font-bold italic leading-snug text-brand-dark sm:text-2xl" data-id="element-200" data-mp="ixkm8nozenap">
            A practical, visual system that brings the major periodontal concepts together in one organized reference.
          </blockquote>
          <p data-id="element-201" data-mp="1d6r87a17zbkt">That’s what I wanted to create when I developed Perio Blueprint™.</p>
          <p data-id="element-202" data-mp="1i37wq5cbzryf">
            Not another collection of disconnected explanations, but a structured educational resource you can open,
            navigate, study, and revisit.
          </p>
        </div>

        <div className="mt-10" data-id="element-203" data-mp="pflqepbpy97v">
          <CTAButton label="I Want One Organized Perio Reference" data-id="element-204" data-mp="ue6hnz8ztik6" />
        </div>
      </div>
    </section>;
}